import React from "react";
import { ObjectFieldTemplateProps } from "@rjsf/utils";
import { ObjectFieldTemplate } from "../../../../../../../Submissions/Templates";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";

export function ObjectFieldTemplatePreview(props: ObjectFieldTemplateProps) {
  const id = props.idSchema.$id;

  if (id === "root") {
    return <ObjectFieldTemplate {...props} />;
  }

  return <GroupInputPreview {...props} />;
}

function GroupInputPreview(props: ObjectFieldTemplateProps) {
  return (
    <BuilderFieldWrapper isGroupWrapper role="group" aria-label="Field group">
      <ObjectFieldTemplate {...props} isSubmissionBuilder />
    </BuilderFieldWrapper>
  );
}
